/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../generated/graphql/types';
import { ProductCardFragmentDoc } from './productCard.fragment.generated';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetProductCardsQueryVariables = Types.Exact<{
  saleChannel: Types.SaleChannelInput;
  productIds:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input'];
  offerOptions: Types.OfferOptions;
}>;

export type GetProductCardsQuery = { __typename?: 'Query' } & {
  offersByProductIds: Types.Maybe<
    { __typename?: 'ChannelOffers' } & {
      offers: Array<
        { __typename?: 'ChannelOffer' } & Pick<
          Types.ChannelOffer,
          'productId' | 'variantsCount'
        > & {
            sku: { __typename?: 'ChannelOfferSku' } & Pick<
              Types.ChannelOfferSku,
              'title' | 'modelId'
            > & {
                images: Array<
                  { __typename?: 'ChannelOfferSkuImage' } & Pick<
                    Types.ChannelOfferSkuImage,
                    'thumbnailUrl'
                  >
                >;
                masterProduct: {
                  __typename?: 'ChannelOfferSkuMasterProduct';
                } & Pick<
                  Types.ChannelOfferSkuMasterProduct,
                  'slug' | 'articleId' | 'masterCategoryId'
                > & {
                    brand: Types.Maybe<
                      { __typename?: 'ChannelBrand' } & Pick<
                        Types.ChannelBrand,
                        'id' | 'title' | 'logo'
                      >
                    >;
                  };
              };
            pricing: { __typename?: 'OfferPricing' } & {
              sellPrice: { __typename?: 'OfferPrice' } & Pick<
                Types.OfferPrice,
                'amountVatIncluded' | 'amountVatExcluded' | 'currency'
              >;
              retailPrice: Types.Maybe<
                { __typename?: 'OfferPrice' } & Pick<
                  Types.OfferPrice,
                  'amountVatIncluded' | 'currency'
                >
              >;
            };
            commercialAnimation: Types.Maybe<
              { __typename?: 'CommercialAnimationAttributes' } & Pick<
                Types.CommercialAnimationAttributes,
                'tags'
              >
            >;
            coldDeliveryOffers: Types.Maybe<
              { __typename?: 'ColdDeliveryOffers' } & Pick<
                Types.ColdDeliveryOffers,
                'hasExpressOffer' | 'isMf'
              > & {
                  cheapestOffer: Types.Maybe<
                    { __typename?: 'ColdDeliveryOffer' } & {
                      deliveryPrice: { __typename?: 'DeliveryPrice' } & Pick<
                        Types.DeliveryPrice,
                        'amount'
                      >;
                    }
                  >;
                }
            >;
            productRating: Types.Maybe<
              { __typename?: 'ArticleRatingStats' } & Pick<
                Types.ArticleRatingStats,
                'average' | 'total'
              >
            >;
          }
      >;
    }
  >;
};

export const GetProductCardsDocument = /*#__PURE__*/ `
    query GetProductCards($saleChannel: SaleChannelInput!, $productIds: [String!]!, $offerOptions: OfferOptions!) {
  offersByProductIds(
    saleChannel: $saleChannel
    productIds: $productIds
    offerOptions: $offerOptions
  ) {
    offers {
      ...ProductCard
    }
  }
}
    ${ProductCardFragmentDoc}`;

export function useGetProductCardsQuery(
  options: Omit<Urql.UseQueryArgs<GetProductCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetProductCardsQuery, GetProductCardsQueryVariables>({
    query: GetProductCardsDocument,
    ...options,
  });
}
